import type {InstagramLikeMediaTriggerStruct} from '@cohort/shared/apps/instagram/triggers/likeMedia';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaUnverified from '@cohort/wallet/components/challenges/OpenCtaUnverified';
import {useTranslation} from 'react-i18next';

const InstagramLikeMediaTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<InstagramLikeMediaTriggerStruct>
> = ({config, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-instagram', {
    keyPrefix: 'triggerIntegrations.like-media',
  });

  return (
    <OpenCtaUnverified
      url={config.url}
      ctaTitle={t('ctaTitle')}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
    />
  );
};

export default InstagramLikeMediaTriggerActionCtaComponent;
